
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Memorial Ratnagiri District Selection Chess Tournament 2025 </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-md-12">
              <div class="sec-title">
                <h2><span>G H Raisoni Memorial Ratnagiri District Selection Chess Tournament 2025 – Concludes Successfully!</span></h2>
              </div>
              <p>The G H Raisoni Memorial Ratnagiri District Selection Chess Tournament 2025 (Open & Women categories) concluded today with a vibrant display of talent, strategy, and sportsmanship.</p>

              <p>We were honored to welcome Prof. Shrikant Dudagikar, Joint Secretary of R. E. Society, as the Chief Guest for the closing ceremony. Joining him was Mr. Anant Gokhale, Senior Chess Player and Development Officer at LIC of India, who felicitated the prize winners.</p>

              <p>The tournament was further enriched by the gracious presence of veteran chess players Mr. Suhas Kamtekar and Mr. Subhash Shirdhankar, who attended both the opening and closing ceremonies. We also extend our thanks to Mr. Mangesh Modak, Treasurer of RDCA, for his continued support throughout the event.</p>

              <p>This successful tournament showcased the growing chess culture in Ratnagiri and provided a valuable platform for local players to shine. Congratulations to all participants and winners!</p>
            </div>


        </div>

        <div class="col-lg-12">
            <div class="gall-ery">
                <div class="row">
                    <div class="col-md-8">
                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a> -->
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-1.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-1.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-2.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-2.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-3.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25-3.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>

</section>

